<template>
  <div class="py-32 md:py-48 text-center">
    <SvgIcon :name="icon" :class="['mb-4 w-24 h-24 mx-auto', iconClasses]" />
    <div v-dompurify-html="content"></div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },

    iconClasses: {
      type: String,
      default: '',
    },

    content: {
      type: String,
      default: '',
    },
  },
}
</script>
